import { VCard } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VCard,
    { staticClass: "mt-2 mr-2 pa-2 text-center", attrs: { flat: "" } },
    [
      _c(VProgressCircular, {
        attrs: { indeterminate: "", color: "primary" },
      }),
      _c("span", [_vm._v(" " + _vm._s(_vm.$t(_vm.keyMessage)) + " ")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }